module.exports = __webpack_public_path__ + "static/media/WBtext.fd879b3f.svg";